import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Eyebrow, Reveal } from "./Reveal";

const BENTO_IMG =
  "https://images.pexels.com/photos/17057573/pexels-photo-17057573.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const CARD_ROUTES = [
  "/expertises/conseil-capital-prive",
  "/expertises/origination-execution",
  "/expertises/operations-structuration",
  "/investissements",
  "/expertises/reglementaire-conformite",
  "/clients/gestion-fortune",
];

export const Services = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <section id="expertises" data-testid="services-section" className="bg-[#FBF8F3] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <Eyebrow>{t.services.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.15] tracking-tight text-[#0A1F18] sm:text-4xl lg:text-5xl">
            {t.services.title}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5C6B64]">{t.services.sub}</p>
        </Reveal>

        <div className="grid gap-px border border-[#E4DDD0] bg-[#E4DDD0] md:grid-cols-2 lg:grid-cols-4">
          {t.services.items.map((item, i) => {
            const featured = i === 0;
            const wide = i === 5;
            return (
              <Reveal
                key={item.title}
                delay={i * 0.07}
                className={featured ? "md:col-span-2 lg:row-span-2" : wide ? "md:col-span-2" : ""}
              >
                <article
                  data-testid={`service-card-${i}`}
                  onClick={() => navigate(CARD_ROUTES[i])}
                  className={`group relative flex h-full cursor-pointer flex-col justify-between overflow-hidden bg-white p-8 transition-colors duration-500 hover:bg-[#F3EFE6] ${
                    featured ? "min-h-[320px]" : "min-h-[240px]"
                  }`}
                >
                  {featured && (
                    <>
                      <img
                        src={BENTO_IMG}
                        alt=""
                        className="absolute inset-0 h-full w-full object-cover opacity-40 transition-opacity duration-700 group-hover:opacity-55"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-white via-white/70 to-white/20" />
                    </>
                  )}
                  <div className="relative flex items-start justify-between">
                    <span className="font-mono text-xs tracking-[0.3em] text-[#B36C45]">
                      0{i + 1}
                    </span>
                    <ArrowUpRight className="h-4 w-4 text-[#5C6B64] opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:opacity-100" />
                  </div>
                  <div className="relative mt-10">
                    <h3
                      className={`font-display font-semibold tracking-tight text-[#0A1F18] ${
                        featured ? "text-2xl sm:text-3xl" : "text-xl"
                      }`}
                    >
                      {item.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-[#5C6B64]">{item.desc}</p>
                  </div>
                  <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-[#C87D55] transition-[width] duration-500 group-hover:w-full" />
                </article>
              </Reveal>
            );
          })}

          <Reveal delay={0.4} className="md:col-span-2">
            <button
              data-testid="services-cta-card"
              onClick={() => navigate("/contact")}
              className="group flex h-full min-h-[200px] w-full flex-col items-start justify-between bg-[#C87D55] p-8 text-left transition-colors duration-500 hover:bg-[#B36C45]"
            >
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#FBF8F3]/80">
                Columbus · Mandat
              </span>
              <div>
                <span className="font-display text-xl font-semibold tracking-tight text-[#FBF8F3]">
                  {t.services.cta}
                </span>
                <ArrowUpRight className="mt-3 h-6 w-6 text-[#FBF8F3] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
